module.exports = __webpack_public_path__ + "media/images/SpillCenter-Logo_v1-29c7c4be86b78cea965d336fba2f2c86.svg";